import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

type Vars = {
  legRunIds: number[];
  side: 'loading' | 'unloading';
  lat: number;
  lng: number;
};

type Result = {
  updatedWaypointCount: number;
  updatedPlaceCount: number;
};

// 複数 legRun の積/降 waypoint 座標と、(name, address) 完全一致する Place の座標を一括更新する。
// 同一トランザクションで実行される（片方だけが更新されることは無い）。
export const useBulkUpdateWaypointLocationMutation = () =>
  useMutation<Result, Error, Vars>({
    mutationFn: async ({ legRunIds, side, lat, lng }) => {
      const res = await axios.post<{
        updated_waypoint_count: number;
        updated_place_count: number;
      }>('/api/v5/shipment_order_waypoints/location_updates', {
        data: {
          leg_run_ids: legRunIds,
          side,
          latitude: lat,
          longitude: lng,
        },
      });
      return {
        updatedWaypointCount: res.data.updated_waypoint_count,
        updatedPlaceCount: res.data.updated_place_count,
      };
    },
  });
